import { ApiClient } from './apiClient';
import { authService } from './authService';

/** The app-wide API client; its token always comes from the current auth service. */
export let api: ApiClient = new ApiClient(() => authService.idToken());
/** Test seam. */
export function setApi(client: ApiClient) {
  api = client;
}
